const messages = {
    // fallbackLng
    en: {
        // ns e defaultNS 
        translations: {
            titles: {
                homeTitle: 'Aqcion'
            },
            navbar: {
                op1: 'Home',
                op2: 'Client', 
                op3: 'Team', 
                op4: 'Contact',
                op5: 'Pages',
                    op6: 'Aqcion Blog',
            },
            homeMessages: {
                homeText: 'Welcome to our project and website development company, founded in 2023 with the aim of providing high quality digital solutions to our clients.',
                homeText2: 'We are a team passionate about technology and innovation, and we are always looking for the best practices and the latest trends in the market to offer excellent services.'
            },
            servicosMessages: {
                text1: 'Services',
                text2: 'We offer',
                text3: 'With the growing popularity of the QR Code around the world, it is important to have a company specialized in this technology to ensure that your projects are executed with efficiency and quality. With our QR Code technology, we offer services specialized in creating innovative and practical solutions for companies and end users. With this, it is possible to implement effective marketing strategies, increase security and optimize processes.',
                
                titleservicos1: 'Projects',
                textservicos1: 'We guarantee to achieve goals, ideas and your expectations of success.',
                
                titleservicos2: 'Trainings',
                textservicos2: 'We offer handling and maintenance training along with software training.',

                titleservicos3: 'Technologies',
                textservicos3: 'We bring to the customer advanced technologies and within the current market.',

                titleservicos4: 'Support',
                textservicos4: 'We have support for our services, customer training and direct service.',
            },
            notaMessages: {
                text1: 'hashtags',
                text2: 'Aqcion Digital',

                textparagrafo1: 'We understand that each client has unique needs, which is why we offer a personalized service focused on the specific needs of each project. From idea conception to final product delivery, we work closely with our customers to ensure that the solutions we develop meet their expectations and needs.',
                textparagrafo2: 'Our team also provides maintenance services, ensuring projects and websites remain up-to-date and running smoothly. We run regular tests to make sure everything is running smoothly and we resolve any issues that may arise.',
                textparagrafo3: 'In addition, we offer training services so that our clients can keep their websites and projects up to date and in full working order. With personalized training, our customers have the opportunity to learn the necessary skills to manage and update their own projects, becoming more autonomous and reducing maintenance costs',
                textparagrafo4: 'We are committed to providing quality digital solutions that meet our customers needs while exceeding their expectations. Contact us to learn more about our services and how we can help you achieve your digital goals.',
            },
            faq: {
                title: 'FAQ',
                subtitle: 'Any question??',
                text: 'Here are some questions we get frequently already answered for you.',

                pergunta1: 'Does Aqcion offer training and support for software solutions?',
                resposta1: 'We offer training and support for software solutions to help them learn to operate effectively and efficiently. We also provide ongoing technical support to ensure the software is working properly and help resolve any issues that may arise.',

                pergunta2: 'And how does the LGPD law work?',
                resposta2: 'We follow the guidelines established by the General Data Protection Law (LGPD), we adopt appropriate technical and organizational measures to guarantee the protection of personal data.',

                pergunta3: 'Will I have my expectations met?',
                resposta3: 'Aqcion Digital ensures that your expectations are met, for this, we follow some good practices, such as understanding the customers needs, clear communication about the process to be carried out, setting goals, among others.',

                pergunta4: 'How does Aqcion keep up with the latest technology trends?',
                resposta4: 'We invest in research and development for new technologies and improve existing ones, keeping within the job market along with qualified professionals to manage and implement cutting-edge technologies.',

                pergunta5: 'Why QRCode and AI?',
                resposta5: 'An innovative company uses QR code and artificial intelligence to offer a more efficient and personalized shopping experience to its customers.',

                pergunta6: 'Is Aqcion reliable?',
                resposta6: 'We demonstrate the ability to fulfill our obligations and promises to customers, we are a company of total transparency and an open mind for clear communication and we offer a work of total quality!',
            },
            feedbacks: {
                title: 'Feedbacks',
                subtitle: 'What our customers say about us',
                text: 'Central to the way we work is our focus on building strong relationships with our customers.',

                feed1: '“I am very impressed with the work of the company Aqcion Digital. They developed a custom website for my company that is easy to use and has significantly improved our operational efficiency. The development team was professional and worked with me to ensure the app met my specific needs.',
                feed2: '“The development process was very smooth and the development team was very responsive to our needs. We couldnt be more pleased with the end result.',
                feed3: '“They were very approachable throughout the development process and did a great job of keeping us updated on the progress of the project. I recommend it to everyone who needs technology development services.',

                tecnologias: 'Some technologies we use ',
            },
            ceo: {
                title: 'CEO',
                subtitle: 'Team',
                text: 'Team of Developers and Founders of Aqcion Digital.',

                nome1: 'Luiz Felipe Menezes',
                cargo1: 'Research and Development Manager',

                nome2: 'Thaiza Favarelli',
                cargo2: 'Developer FullStack',

                nome3: 'Gustavo Nonato',
                cargo3: 'Social Media and Advertising Manager',
            },
            contato: {
                title: 'CONTACT US',
                text1: 'We love to hear from you!',
                text2: 'If in doubt, get in touch.',
                text3: 'How can we help?',
                email: 'aqcionDigi@gmail.com',

                titleforms: 'Send us a message',
                lblnome: 'Full name*',
                lblemail: 'Email*',
                lblPhone: 'Contact number*',
                lblmensagem: 'Message*',
                btnenviar: 'Send Message',
            },
            footer: {
                text: 'We transform ideas into technological innovation, driving the present and creating the future!',
                tecnologia: 'Some technologies we provide',
                by: 'Designer and development of',
            },
            pageblog: {
                title1: 'Development Tools',
                text1: 'In our company, we are always in search of the most advanced technologies for the development of incredible projects. We use a variety of cutting-edge tools and technologies, ensuring exceptional results for our clients.',
                
                title2: 'Some Technologies Used',
                text2: '✨ One of our main technologies is Firebase, which allows us to create web and mobile applications with powerful features such as cloud storage, user authentication, and real-time notifications. With it, we provide an agile and secure experience to our product users.',
                text3: '💻 Additionally, we rely on React and FlutterFlow, interface development frameworks that enable us to create modern and responsive interfaces for our applications. With them, we ensure a seamless user experience, regardless of the platform used.',
                text4: '🌐 For the development of our backend, we trust Django and MySQL. With these robust technologies, we create scalable, secure, and efficient systems capable of handling large volumes of data and ensuring the stability of our applications.',
                text5: '💰 For online financial transactions, we use Stripe, a secure and reliable electronic payment platform. This allows us to offer a smooth and secure purchasing experience to our customers, increasing trust and satisfaction.',
                text6: '⚡ And finally, for frontend development, we rely on Tailwind and HTML, which enable us to create responsive layouts and custom styles, ensuring a modern and appealing appearance for our applications and websites.',
                text7: '#advancedtechnology #projectdevelopment #innovation #userexperience #exceptionalresults',
                text8: '🚀 With this range of advanced technologies, we are ready to develop incredible projects and offer innovative solutions to our clients. Contact us and discover how we can take your business to the next level!',
            
                fraseaqcion: 'Life is better for those who do their best to have the best.',
            
                cardtext1: 'Stay updated on innovative projects!',
                cardtext2: 'Always make good use of technology.',
            
                fraseaqcion2: 'We turn ideas into reality, leveraging digital potential to conquer the future.',
            
                topictitle1: 'Mission',
                topictitle2: 'Vision',
                topictitle3: 'Values',
    
                topicname1: 'Technological solutions',
                topicname2: 'Recognition',
                topicname3: 'Focus, appreciation, innovation, quality',

                topictext1: 'Develop innovative and personalized technological solutions to meet the needs of our clients. Exceed clients expectations and contribute to their success. Additionally, provide training to empower clients to efficiently utilize our solutions.',
                topictext2: 'Aqcion Digital aims to be recognized as a benchmark in the market for developing customized technologies with quality and excellence.',
                topictext3: 'Our company prioritizes excellence in customer service, with a focus on teamwork and transparency. We pursue quality and innovation in all stages of development, providing creative and disruptive solutions for a competitive advantage.',
            },
            idioma: {
                text: 'Select a language',
            },
            maps: {
                title: 'Technical Support:',
                suporte: '19 99423-8412',
                email: 'aqciondigi@gmail.com',
                text1: 'Report bugs and ask questions.',
                text2: 'Get a quote!',
                endereco : 'Location: Av. Brasil Sul, 2001 - Parque Res. Nardini, Americana - SP, 13465-770',
            }
        }
    }
}

export { messages }